import { useMemo } from 'react'
import type { ShapeType } from '@/lib/shapes/types/shape-type'
import { resolveCanvasCursor, resolveShapeCreationCursor } from '../helpers/canvas-cursor'
import type { TextDragCreateState } from '../types/canvas-drag-state'

/** The pasteboard's cursor for the live tool, mode and gesture. */
export function useCanvasCursor({
  selectedShape,
  isDragPanning,
  isPanInteractionActive,
  isTextLinkingActive,
  textDragCreate,
  isMarqueeZoomMode,
  zMarqueeKeyHeld,
  isPenEditMode,
  penEditHoverKind,
  isInPenToolMode,
  isNodeEditMode,
  isInShapeCreationMode,
  isInTextCreationMode,
}: {
  selectedShape: ShapeType | null
  isDragPanning: boolean
  isPanInteractionActive: boolean
  isTextLinkingActive: boolean
  textDragCreate: TextDragCreateState | null
  isMarqueeZoomMode: boolean
  zMarqueeKeyHeld: boolean
  isPenEditMode: boolean
  penEditHoverKind: 'endpoint' | 'anchor' | 'segment' | null
  isInPenToolMode: boolean
  isNodeEditMode: boolean
  isInShapeCreationMode: boolean
  isInTextCreationMode: boolean
}): string | undefined {
  const cursorUrlForShape = useMemo(
    () => resolveShapeCreationCursor(selectedShape),
    [selectedShape]
  )

  return useMemo(
    () =>
      resolveCanvasCursor({
        isDragPanning,
        isPanInteractionActive,
        isTextLinkingActive,
        isTextDragCreating: Boolean(textDragCreate),
        isMarqueeZoomMode,
        zMarqueeKeyHeld,
        isPenEditMode,
        penEditHoverKind,
        isInPenToolMode,
        isNodeEditMode,
        isInShapeCreationMode,
        cursorUrlForShape,
        isInTextCreationMode,
      }),
    [
      cursorUrlForShape,
      isDragPanning,
      isPenEditMode,
      penEditHoverKind,
      isInPenToolMode,
      isNodeEditMode,
      isInShapeCreationMode,
      isInTextCreationMode,
      isMarqueeZoomMode,
      zMarqueeKeyHeld,
      isPanInteractionActive,
      isTextLinkingActive,
      textDragCreate,
    ]
  )
}
